module.exports = __webpack_public_path__ + "static/media/Dashboard.module.3688fd93.less";


//////////////////
// WEBPACK FOOTER
// ./src/views/app/components/Dashboard.module.less
// module id = 733
// module chunks = 0